<template>
  <div
    id="advanceformsettingswrapperdiv"
    :class="$style['adl-advance-filter-content']"
  >
    <h4>{{ contentInfo.heading }}</h4>

    <div :class="$style['cf-supportingText']">{{ contentInfo.subHeading }}</div>

    <div
      class="right-body-container right-body-white-container chart-container"
      :class="$style['cf-chart-rendering']"
    >
      <div :class="$style['cf-formWidth']">
        <adl-eloqua-form
          :data="formModel"
          :loading="loading"
          @formChange="onChangeFormModel"
        >
        </adl-eloqua-form>
      </div>
    </div>
  </div>
</template>
<script>
import AdlEloquaForm from "../custom/eloqua-form/EloquaForm.vue";
export default {
  props: {
    contentInfo: {
      type: Object,
    },
    formModel: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  components: { AdlEloquaForm },
  computed: {},

  async created() {},
  mounted() {},
  methods: {
    onChangeFormModel(form) {
      this.$emit("onChangeFormModel", form);
    },
  },
};
</script>
<style lang="scss" module>
.adl-advance-filter-content {
  height: calc(85vh - 114px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 4px;
  padding-bottom: 16px;
  .cf-formWidth {
    width: 50%;
  }
  .cf-supportingText {
    padding-top: $mds-space-1-x;
    padding-bottom: $mds-space-1-x;
  }

  .cf-chart-rendering {
    margin-top: $mds-space-1-x;
  }
}
</style>
